import React from 'react';
import { message } from 'antd';
import { Toast } from 'antd-mobile';
import { isPc } from '@/utils/utils';
import axios, { AxiosResponse } from 'axios';
/** @deprecated isErrorPc 或者 isErrorMobile */
export const isError = <T extends { code?: number|string; message?: string,status?:any,statusText?:string,request?:any,data?:any } = {}>(res: T,) => {
  if (res.code !== 200) {
    if (isPc) {
      message.error(res.message);
    } else {
      Toast.show({
        icon: 'fail',
        content: res.message
      });
    }
    return true;
  }
  return false;
};


export type ErrorModel = AxiosResponse<AxiosHttpPromise<any>>



export const isErrorHttp = <T extends ErrorModel>(res: T,) => {
  const error = {
    isError: false,
    message:''
  }
  if(typeof res.status == 'number' && res.request){
    if(res.status != 200){
      error.isError = true
      error.message = `status: ${res.status}, statusText: ${res.statusText}`
      return error
    }
  }
  if(axios.isAxiosError(res)){
    const { code, status, statusText } = res
    error.isError =true
    let message = res.message
    if(code == 'ERR_NETWORK'){
      message = '网络异常'
    }
    error.message = `axios code: ${code}, ${message}`
    return error
  }
  return error
}